import React from 'react';
import { DEFAULT_PRICE_DECIMAL_LENGTH, DEFAULT_DECIMAL_SEPARATOR, DEFAULT_THOUSAND_SEPARATOR, ROOF_INT_VAL } from "../utils/constants";
import { empty } from "./generalHelper";

export const padLeft = (nr, n, str) => {
    return Array(n-String(nr).length+1).join(str||'0')+nr;
};

export const validPhone = str => {
    return /^\+?\d{9,15}$/.test(str);
};

export const normalizePhoneLeadingZeros = str => {
    if (typeof str !== "string") {
        return str;
    }

    return str
        .replace(/^\+62/, "0")
        .replace(/^00+/, "0");
};

export const validEmail = str => {
    return /(.+)@(.+){2,}\.(.+){2,}/.test(str);
};

export function randomString(length) {
    return Math.round(
        Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)
    )
        .toString(36)
        .slice(1);
}

export function nl2br(str, isXhtml) {
    // Some latest browsers when str is null return and unexpected null value
    if (typeof str === 'undefined' || str === null) {
        return '';
    }

    // Adjust comment to avoid issue on locutus.io display
    const breakTag =
        isXhtml || typeof isXhtml === 'undefined' ? '<br />' : '<br>';

    return (str + '').replace(/(\r\n|\n\r|\r|\n)/g, breakTag + '$1');
}

export function nl2brReact(str) {
    const newlineRegex = /(\r\n|\r|\n)/g;

    if (typeof str === 'number') {
        return str;
    } else if (typeof str !== 'string') {
        return '';
    }

    return str.split(newlineRegex).map(function(line, index) {
        if (line.match(newlineRegex)) {
            return React.createElement('br', { key: index });
        }
        return line;
    });
}

export function createInitials(str) {
    const strArray = str.split(' ');
    let initials = '';

    if (strArray.length === 1) {
        initials = str.charAt(0);
    } else if (strArray.length === 2) {
        strArray.map(name => {
            initials += name.charAt(0);
            return name;
        });
    } else if (strArray.length > 2) {
        const nameCount = strArray.length;
        initials += strArray[0].charAt(0);
        initials += strArray[nameCount - 1].charAt(0);
    } else {
        initials = 'NA';
    }

    return initials;
}

export function number_format(number, decimals, decPoint, thousandsSep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    const n = !isFinite(+number) ? 0 : +number;
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    const sep = typeof thousandsSep === 'undefined' ? '.' : thousandsSep;
    const dec = typeof decPoint === 'undefined' ? ',' : decPoint;
    let s = '';

    const toFixedFix = function(n, prec) {
        const k = Math.pow(10, prec);
        return '' + (Math.round(n * k) / k).toFixed(prec);
    };

    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }

    return s.join(dec);
}

export const formatOptionalDecimal = (value, decimalLength = 2) => {
    const numericValue = parseFloat(value) || 0;
    const precisionFactor = Math.pow(10, decimalLength);
    const hasDecimal = Math.round((numericValue - Math.trunc(numericValue)) * precisionFactor) !== 0;
    return number_format(numericValue, hasDecimal ? decimalLength : 0);
};

export const processDecimalInput = (inputText, callback, decimalSeparator = DEFAULT_DECIMAL_SEPARATOR, thousandSeparator = DEFAULT_THOUSAND_SEPARATOR) => {
    const inputTextString = !empty(inputText) ? inputText : '0';
    const decimalSeparatorExists = inputTextString.includes(decimalSeparator);
    let value = 0;
    let valueText = '0';

    if(!decimalSeparatorExists){
        let nonDecimalValue = inputTextString.replace(/\D/g, '');
        if(nonDecimalValue.length > 9){
            nonDecimalValue = ROOF_INT_VAL;
        }else{
            nonDecimalValue = parseFloat(nonDecimalValue);
        }

        value = nonDecimalValue;
        valueText = number_format(nonDecimalValue, 0, decimalSeparator, thousandSeparator);
    }else{
        const decimalArray = inputTextString.split(decimalSeparator);
        let firstPartDecimal = decimalArray[0].replace(/\D/g, '');
        if(firstPartDecimal.length > 9){
            firstPartDecimal = ROOF_INT_VAL;
        }
        const firstPartDecimalFormatted = number_format(firstPartDecimal, 0, decimalSeparator, thousandSeparator);
        let secondPartDecimal = decimalArray[1].replace(/\D/g, '').substr(0, DEFAULT_PRICE_DECIMAL_LENGTH);

        value = parseFloat(firstPartDecimal + '.' + secondPartDecimal);
        valueText = firstPartDecimalFormatted + decimalSeparator + secondPartDecimal;
    }

    callback(value, valueText);
};